import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';

import { Button } from '@/components';
import style from './index.module.scss';

import { useLeaveGroup } from '../../hooks';
type ModalProps = {
  hide(): void;
  groupId: number;
};

export const LeaveGroupModal = ({ hide, groupId }: ModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync, isLoading } = useLeaveGroup(groupId);
  const onConfirm = useCallback(() => {
    mutateAsync().then(res => {
      if (res.is_success) {
        hide();
      }
    });
    hide();
  }, [hide, mutateAsync]);
  return (
    <div className={style.leaveGroupModal}>
      <div className={style.header}>{t('GroupModalManager_LeaveGroupModal.8ev9gm')}</div>
      <div className={style.desc}>{t('GroupModalManager_LeaveGroupModal.1isdr9k')}</div>
      <div className={style.buttons}>
        <Button type="default" className={style.button} onClick={hide}>
          {t('GroupModalManager_LeaveGroupModal.x9d2fu')}
        </Button>
        <Button type="primary" className={style.button} loading={isLoading} onClick={onConfirm}>
          {t('GroupModalManager_LeaveGroupModal.179d1nk')}
        </Button>
      </div>
    </div>
  );
};
